/**
 * Rate limits for different geopl services (requests per second)
 * @see https://geoservices.ign.fr/documentation/limites-techniques
 */

export const GEOPL_RATE_LIMITS = {
  wmsRaster: 40,
  wmsVector: 50,
  wfs: 30,
  download: 10,
  partialDownload: 200,
  csw: 15,
  geocoding: 50,
  autocomplete: 10,
  elevation: 5,
  routing: 5,
  isochrone: 5,
  search: 10,
  vectorTiles: 400,
  lidarPyramid: 200,
  lidarCopc: 200,
  lidarDownload: 10,
} as const;
